import {t} from '@lingui/core/macro';

import {IColumn} from 'shared/ui/Table/Table';

import IPortIncident from '../model/PortIncident/IPortIncident';

export function getPortIncidentColumns(hideMonitor: boolean): IColumn[] {
    return [
        {label: t`Статус`, sort: 'resolved'},
        ...(hideMonitor ? [] : [{label: t`Порт`}]),
        {label: t`Желаемое состояние`},
        {label: t`Начало`, sort: 'createdAt'},
        {label: t`Окончание`, sort: 'resolvedAt'},
        {label: t`Длительность`},
        {label: ''},
    ];
}

export function isPortIncidentOpen(incident: Pick<IPortIncident, 'resolved'>): boolean {
    return !incident.resolved;
}

export function getPortIncidentStatusLabel(isOpen: boolean): string {
    return isOpen ? t`Открыт` : t`Решён`;
}

export function getPortIncidentDurationSeconds(
    incident: Pick<IPortIncident, 'created_at' | 'resolved_at'>,
): number {
    const createdAt = new Date(incident.created_at).getTime();
    const endAt = incident.resolved_at ? new Date(incident.resolved_at).getTime() : Date.now();

    return Math.max(0, Math.floor((endAt - createdAt) / 1000));
}

export function getPortIncidentDateFormat(isEnglish: boolean): string {
    return isEnglish ? 'YYYY-MM-DD, in HH:mm' : 'DD.MM.YYYY, в HH:mm';
}

export function hasPortRecoveryResults(incident: Pick<IPortIncident, 'recovery_locations'>): boolean {
    return (incident.recovery_locations ?? []).length > 0;
}
